"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext } from "react";
const DiscoveryMobileMenuCloseContext = createContext<(() => void) | null>(null);
export const DiscoveryMobileMenuCloseProvider = DiscoveryMobileMenuCloseContext.Provider;

/** Closes the hamburger when a slotted mobile account link is chosen. */
export function useDiscoveryMobileMenuClose() {
  const $ = _c(2);
  const close = useContext(DiscoveryMobileMenuCloseContext);
  let t0;
  if ($[0] !== close) {
    t0 = () => close?.();
    $[0] = close;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}